const PIERCING_SERVICES = [
  {
    id: 1,
    title: 'Piercing Experience for One',
    subtext: '(20 minutes, up to 3 piercings, £20 not including jewellery)',
  },
  {
    id: 2,
    title: 'Piercing Experience for Two',
    subtext: '(40 minutes, up to 3 piercings per person, £35 not including jewellery)',
  },
  {
    id: 3,
    title: 'Piercing Check-up',
    subtext: '(10 minutes, free, not including jewellery purchase)',
  },
];

const WELDING_SERVICES = [
  {
    id: 4,
    title: 'Forever-weld Experience for One (20 minutes)',
  },
  {
    id: 5,
    title: 'Forever-weld Experience for Two (40 minutes)',
  },
  {
    id: 6,
    title: 'Forever-weld Adjustment (10 minutes)',
  },
];

const STUBS_APPOINTMENT_IDS = [71271, 71352, 71283, 71277, 71358, 71364];
const STAGING_APPOINTMENT_IDS = [70873, 70891, 70885, 70879, 70897, 70903];
const PROD_APPOINTMENT_IDS = [71039, 71045, 71025, 71051, 71057, 71063];
const WELDING_APPOINTMENT_IDS = [71277, 71358, 71364, 70879, 70897, 70903, 71051, 71057, 71063];

const PIERCING_SERVICE_TITLE = 'Piercing Experience';
const WELDING_SERVICE_TITLE = 'Welding Experience';
const PIERCING_ADVISOR = 'Piercing Advisor';
const WELDING_ADVISOR = 'Welding Advisor';
const PIERCING_EDIT_TITLE = 'Piercing Type';
const WELDING_EDIT_TITLE = 'Welding Type';

export {
  PIERCING_SERVICES,
  WELDING_SERVICES,
  STUBS_APPOINTMENT_IDS,
  STAGING_APPOINTMENT_IDS,
  PROD_APPOINTMENT_IDS,
  WELDING_APPOINTMENT_IDS,
  PIERCING_SERVICE_TITLE,
  WELDING_SERVICE_TITLE,
  PIERCING_ADVISOR,
  WELDING_ADVISOR,
  PIERCING_EDIT_TITLE,
  WELDING_EDIT_TITLE,
};
